import gql from 'graphql-tag';

export default gql`
  mutation createOneLessonExerciseMutation($record: CreateOneLessonExerciseInput!) {
    createOneLessonExerciseMutation(record: $record) {
      record {
        creator {
          _id
        }
        student {
          _id
        }
        course {
          _id
        }
        title
        notes
        id
        _id
        createdAt
        data { course courseCategory student isShared isTodo standaloneFile }
      }
    }
  }
`;
